<!-- Rendered inside the lot-details vb-dialog, which owns the title + close. -->
<div class="alerts">
    <div class="alerts__price">
        <span class="alerts__price-label">Current item price</span>
        <span class="alerts__price-value" *ngIf="currentPrice !== null">
            ${{ currentPrice | number: "1.2-2" }}
        </span>
        <span class="alerts__price-value" *ngIf="currentPrice === null">—</span>
    </div>

    <div class="alerts__section" *ngIf="reminders.length > 0">
        <p class="alerts__eyebrow">Your alerts</p>
        <ul class="alerts__list">
            <li
                class="alerts__row"
                *ngFor="let reminder of reminders"
                [class.is-editing]="
                    isEditing && reminder.id === currentReminder.id
                ">
                <div class="alerts__row-text">
                    <span class="alerts__row-time">
                        {{
                            convertMillisecondsToTime(reminder.notifyAtLabel!)
                        }}
                        before close
                    </span>
                    <span class="alerts__row-meta">
                        {{ methodLabel(reminder) }}
                    </span>
                </div>
                <div class="alerts__row-actions" *ngIf="!isEditing">
                    <vb-icon-button
                        icon="note"
                        label="Edit alert"
                        tipAlign="right"
                        [size]="32"
                        (clicked)="editReminder(reminder)" />
                    <vb-icon-button
                        icon="close"
                        label="Delete alert"
                        tipAlign="right"
                        [danger]="true"
                        [size]="32"
                        (clicked)="deleteReminder(reminder)" />
                </div>
            </li>
        </ul>
    </div>

    <div class="alerts__section" *ngIf="!isLoading">
        <p class="alerts__eyebrow">
            {{ isEditing ? "Edit alert" : "New alert" }}
        </p>
        <p class="alerts__hint" *ngIf="!allTimesUsed">
            We'll notify you of this lot's price at the time you pick before
            the auction closes.
        </p>

        <p class="alerts__field-label">Alert me before close</p>
        <div class="alerts__chips">
            <vb-toggle-chip
                *ngFor="let time of alertTimeOptions"
                [small]="true"
                [disabled]="time.unavailable"
                [selected]="currentReminder.notifyAtLabel === time.value"
                (toggled)="selectAlertTime(time.value)">
                <span
                    class="alerts__chip-label"
                    [class.is-unavailable]="time.unavailable"
                    >{{ convertMillisecondsToTime(time.value) }}</span
                >
            </vb-toggle-chip>
        </div>
        <p class="alerts__empty" *ngIf="allTimesUsed">
            No times left to choose from — every alert time has already
            passed or is in use.
        </p>

        <ng-container *ngIf="!allTimesUsed">
            <p class="alerts__field-label">Notify me by</p>
            <div class="alerts__chips">
                <vb-toggle-chip
                    [small]="true"
                    [selected]="!!currentReminder.email"
                    (toggled)="toggleMethod('email')">
                    Email
                </vb-toggle-chip>
                <vb-toggle-chip
                    [small]="true"
                    [selected]="!!currentReminder.sms"
                    (toggled)="toggleMethod('sms')">
                    Text
                </vb-toggle-chip>
            </div>

            <p
                class="alerts__summary"
                *ngIf="formValid"
                [innerHTML]="getNotificationText()"></p>
        </ng-container>

        <div class="alerts__actions" *ngIf="isEditing || !allTimesUsed">
            <vb-button
                *ngIf="isEditing"
                variant="ghost"
                size="md"
                (clicked)="cancelEdit()">
                Cancel
            </vb-button>
            <vb-button
                *ngIf="isEditing"
                variant="primary"
                size="md"
                [disabled]="!formValid"
                (clicked)="updateReminder()">
                Update alert
            </vb-button>
            <vb-button
                *ngIf="!isEditing"
                variant="primary"
                size="md"
                [disabled]="!formValid"
                (clicked)="saveReminder()">
                Save alert
            </vb-button>
        </div>
    </div>
</div>
